$(document).ready(() => {
  $('.icon_checkbox').on('change', submitIcons);

  function submitIcons() {
    $('#submit_icons').click();
  }
});
